import http from "@http"

//列表  分页
export function getVideoList(data) {
    return http({
        url: '/lskj-document/api/document/video/list',
        method: "post",
        data
    })
}
// 列表 不分页
export function getVideoAll(data) {
    return http({
        url: '/lskj-document/api/document/video/all',
        method: "post",
        data
    })
}

//查询单条信息
export function videoById(data) {
    return http({
        url: `/lskj-document/api/document/video/byId?id=${data.id}`,
        method: "get",
    })
}

//添加
export function videoAdd(data) {
    return http({
        url: '/lskj-document/api/document/video/add',
        method: "post",
        data
    })
}

//修改
export function updeteVideo(data) {
    return http({
        url: `/lskj-document/api/document/video`,
        method: "put",
        data
    })
}
//删除
export function deleteVideo(data) {
    return http({
        url: `/lskj-document/api/document/video?ids=${data.ids}`,
        method: "delete",
        data
    })
}